module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-rojo_old.7c658aa4.svg";